import { Table, ApiClientConstant } from '@cureskin/api-client';
import { Component, Input, Output, EventEmitter, inject, OnInit, OnDestroy } from '@angular/core';
import { RouterModule } from '@angular/router';
import { OrderService } from '@services/order-service/order.service';
import { CsIconModule } from '@components/icon';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'order-delivered',
  imports: [CsIconModule, CommonModule, RouterModule],
  templateUrl: './order-delivered.component.html',
})
export class OrderDeliveredComponent implements OnInit, OnDestroy {
  public readonly orderService: OrderService = inject(OrderService);
  public readonly ApiClientConstant = ApiClientConstant;

  @Input() isRebrandingBanner: boolean;
  @Input() orderStatusBannerExp: boolean = false;
  @Input() order: Table.Order;
  @Output() addEvents: EventEmitter<any> = new EventEmitter();

  orderedProductsCount: number;
  cancelledProducts: Array<Table.Order['attributes']['productApprovalDetails']['productDetails'][number]> = [];
  shouldShowPartialOrderCancellationUI: boolean;
  cancelledProductsCount: number = 0;
  totalProductsCount: number = 0;

  productImages: string[] = [];
  currentImageIndex: number = 0;
  private imageRotationInterval: ReturnType<typeof setInterval>;

  constructor() {}

  get orderUrl(): string {
    return `/user/order/${this.order?.id}`;
  }

  ngOnInit(): void {
    const approvalData = this.orderService.initializeProductApprovalData(this.order);
    this.cancelledProducts = approvalData.cancelledProducts;
    this.orderedProductsCount = approvalData.orderedProductsCount;
    this.shouldShowPartialOrderCancellationUI = approvalData.shouldShowPartialOrderCancellationUI;
    this.cancelledProductsCount = approvalData.cancelledProductsCount;
    this.totalProductsCount = approvalData.totalProductsCount;

    if (this.orderStatusBannerExp) {
      this.initImageRotation();
    }
  }

  ngOnDestroy(): void {
    if (this.imageRotationInterval) {
      clearInterval(this.imageRotationInterval);
    }
  }

  handleClick(): void {
    this.addEvents.emit();
  }

  private initImageRotation(): void {
    this.extractProductImages();
    if (this.productImages.length > 1) {
      this.imageRotationInterval = setInterval(() => {
        this.currentImageIndex = (this.currentImageIndex + 1) % this.productImages.length;
      }, 2000);
    }
  }

  private extractProductImages(): void {
    if (this.order.get('type') === ApiClientConstant.Order.Type.REGIMEN) {
      const regimenCoverImage = this.order.get('regimen')?.get('regimenCoverImage');
      if (regimenCoverImage) {
        this.productImages = [regimenCoverImage];
      } else {
        const regimenClass = this.order.get('regimen')?.get('class');
        const fallback = regimenClass === 'FACE'
          ? 'https://cdn.cureskin.com/app/img/Skin-Box.png'
          : 'https://cdn.cureskin.com/app/img/Hair-Box.png';
        this.productImages = [fallback];
      }
    } else {
      const rawProducts: any[] = this.order.get('products') || [];
      const products: any[] = JSON.parse(JSON.stringify(rawProducts))
        .map((each: any) => each.product || each);
      this.productImages = products
        .map((product: any) => {
          return (product.rebrandedImageWithoutBackground?.length && product.rebrandedImageWithoutBackground[0])
            || product.productUnboxedImage?.[0]
            || (product.rebrandedImageWithBackground?.length && product.rebrandedImageWithBackground[0]);
        })
        .filter((img: string) => !!img);
    }
  }
}
